<span [ngPlural]="count">
    <ng-template ngPluralCase="=0">{{singular}}</ng-template>
    <ng-template ngPluralCase="=1">{{singular}}</ng-template>
    <ng-template ngPluralCase="other">{{plural}}</ng-template>
</span>
